import { publicConfig } from "@lululemon/ecom-core";
import { stringSanitizer } from "@lululemon/dsp-utils";
import { StoreData } from "@lululemon/dsp-shared";
import { sentryLog } from "@lululemon/dsp-shared/src/logger";
import { loDspOptinSource } from "../../config/opt-in";

interface ILOOptIn {
  email: string;
  storeId: StoreData["id"];
}

const optInToStore = async (data: ILOOptIn): Promise<number> => {
  const loDspOptinFlowAPI = publicConfig.optInFlowApi;
  const { email, storeId } = data;

  try {
    const response = await fetch(loDspOptinFlowAPI, {
      method: "POST",
      body: JSON.stringify({
        email: stringSanitizer.sanitize(email),
        storeId: storeId,
        source: loDspOptinSource
      }),
      credentials: "omit"
    });

    return response.status;
  } catch (e) {
    sentryLog.error(e, {
      context: {
        errorInfo: e
      },
      tags: {
        componentName: "Optin-flow"
      },
      apiContext: {
        url: loDspOptinFlowAPI,
        method: "POST"
      }
    });
    throw new Error(`Failed to post ${e}`);
  }
};

export default optInToStore;
